<template>
  <div class="document" v-if="currentDocument">
    <progress-bar></progress-bar>
    <h3 class="document__header">
      <icon name="envelope-open" height="15" width="20"></icon>
      <span>{{ currentDocument.title }}</span>
    </h3>
    <template v-for="(page, pageIndex) in currentDocument.pages">
      <div class="document__page" :key="page.src">
        <img :src="page.src || `https://docs-cdn.signable.co.uk/large/${currentDocument.fingerprint}-${pageIndex}.jpg`" />
        <template v-if="currentDocument.fields[pageIndex + 1]">
          <template v-for="(field, fieldIndex) in currentDocument.fields[pageIndex + 1]">
            <document-field
              :pageIndex="pageIndex + 1"
              :fieldIndex="fieldIndex"
              :fieldId="field.id"
              :key="`${field.id}-${fieldIndex}`">
            </document-field>
          </template>
        </template>
      </div>
    </template>
    <document-navigation v-if="envelopeDocuments && envelopeDocuments.length > 1"></document-navigation>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar'
import DocumentField from '@/components/DocumentField'
import DocumentNavigation from '@/components/DocumentNavigation'
import { mapGetters } from 'vuex'

export default {
  name: 'document',
  components: {
    ProgressBar,
    DocumentField,
    DocumentNavigation
  },
  computed: {
    ...mapGetters({
      envelopeDocuments: 'envelopeDocuments',
      currentDocument: 'currentDocument'
    })
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-page-shadow: $color-grey
  .document
    float: right
    width: 75%
    padding: $spacing-large $spacing-large 87px
    position: relative
    &__header
      width: 95%
      margin: 0 auto
      background-color: $signable-secondary-3
      padding: $spacing-base
      margin-bottom: -$spacing-base
      color: #fff
      span
        word-break: break-all
        line-height: 1.5
    &__page
      position: relative
      width: 95%
      margin: $spacing-base auto
      box-shadow: 0 5px 20px -5px $color-page-shadow
  // Responsive
  @media screen and (max-width: $screen-size-large)
    .document
      width: 100%
      padding-top: 42px
  @media screen and (max-width: $screen-size-medium)
    .document
      padding: $spacing-large 0 87px
  @media screen and (max-width: $screen-size-small)
    .document
      padding: 47px 0 87px
</style>
